import { render, staticRenderFns } from "./ContractSelectingSupplierDashboard.vue?vue&type=template&id=f0ced668&scoped=true&lang=pug&"
import script from "./ContractSelectingSupplierDashboard.vue?vue&type=script&lang=ts&"
export * from "./ContractSelectingSupplierDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ContractSelectingSupplierDashboard.vue?vue&type=style&index=0&id=f0ced668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ced668",
  null
  
)

export default component.exports